export enum ErrorType {
  NETWORK_ERROR = 'NETWORK_ERROR',
  AUTH_ERROR = 'AUTH_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface GlobalError {
  message: string
  code?: string
  type?: ErrorType
  statusCode?: number
}

export const getErrorType = (statusCode?: number): ErrorType => {
  if (!statusCode) return ErrorType.UNKNOWN_ERROR
  
  if (statusCode === 401) return ErrorType.AUTH_ERROR
  if (statusCode === 403) return ErrorType.FORBIDDEN
  if (statusCode === 404) return ErrorType.NOT_FOUND
  if (statusCode >= 400 && statusCode < 500) return ErrorType.VALIDATION_ERROR
  if (statusCode >= 500) return ErrorType.SERVER_ERROR
  
  return ErrorType.UNKNOWN_ERROR
}

export const getErrorMessage = (error: any): GlobalError => {
  if (typeof error === 'string') {
    return { message: error, type: ErrorType.UNKNOWN_ERROR }
  }
  
  if (error instanceof Error) {
    return {
      message: error.message,
      type: ErrorType.UNKNOWN_ERROR,
    }
  }
  
  if (error?.statusCode || error?.message) {
    return {
      message: error.message || 'An error occurred',
      code: error.code,
      statusCode: error.statusCode,
      type: getErrorType(error.statusCode),
    }
  }
  
  return {
    message: 'An unexpected error occurred',
    type: ErrorType.UNKNOWN_ERROR,
  }
}
